import React, { useState } from 'react';

import { Button, Container, Content } from './styles';

interface CollapsableContentProps {
  buttonTitle?: string;
  flushBottom?: boolean;
  openButtonTitle?: string;
}

const CollapsableContent: React.FC<CollapsableContentProps> = ({ buttonTitle, children, flushBottom, openButtonTitle }) => {
  const [isOpen, setOpen] = useState<boolean>(false);
  return (
    <Container>
      <Button aria-expanded={isOpen} onClick={() => setOpen(!isOpen)} type="button">
        {isOpen && openButtonTitle ? openButtonTitle : buttonTitle || 'Show More +'}
      </Button>
      <Content className={isOpen ? 'active' : ''} flushBottom={flushBottom}>
        {children}
      </Content>
    </Container>
  );
};

export default CollapsableContent;
